"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_CENTERED = exports.TYPE_ERROR = exports.TYPE_DEFAULT = void 0;
const TYPE_DEFAULT = 'default';
exports.TYPE_DEFAULT = TYPE_DEFAULT;
const TYPE_CENTERED = 'centered';
exports.TYPE_CENTERED = TYPE_CENTERED;
const TYPE_ERROR = 'error';
exports.TYPE_ERROR = TYPE_ERROR;
